var map = {
	"./8K4A0229-copy.jpg": 3028,
	"./8K4A0234-copy.jpg": 6771,
	"./8K4A0291-copy.jpg": 7228,
	"./8K4A0295-copy.jpg": 4611,
	"./8K4A0316-copy.jpg": 999,
	"./8K4A0325-copy.jpg": 8412
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8539;